module.exports = __webpack_public_path__ + "resources/img/img_appen_data1_m_en.494aa049f4a093e7aca6581dd409cf63.png";